<template>
  <div class="success-screen">
    <div class="success-box">
      <h2>申辦送出成功</h2>
      <img src="@/assets/icon_success.png" alt="Submission Success" class="success-icon" />
      <p>您的月租申辦資料已經送出<br>
        申辦成功時將以電子郵件和電話通知您</p>
    </div>
    <button @click="reset" class="success-button">回到首頁</button>
  </div>
</template>

<script>
export default {
  methods: {
    reset() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
@import "@/css/apply_success.css";

</style>
